'use strict';

// Test api with test db
// import PocketBase from "pocketbase";
import {isDevMode} from "@angular/core";

///Feedback Urls///
// Test
/* export const feedbackUrl = "http://localhost:2025/api/v1/"; */



/* Live */
// export const feedbackUrl = "https://springapi.telone.co.zw/selfService/v1/feedback/addFeedback";

// Test 2
export const feedbackUrl = "http://172.27.34.22:1999/selfService/v1/feedback/addFeedback";


// Complaints URLs
// Test 1
// export const complaintsUrl = "http://localhost:8090/api/complaints";

// Test 2
export const regionsUrl = "http://172.27.34.22:1999/selfService/v1/feedback/getLeapRegions";

export const complaintsUrl = "http://172.27.34.22:1999/selfService/v1/feedback/addFeedback";

export const exchangeUrl = "http://172.27.34.22:1999/selfService/v1/feedback/getExchange/"; // get by appObjectNumber
